















import Vue from 'vue'
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class TextInput extends Vue{
    @Prop() private inputType!: string;
    @Prop() private value!: string;
    @Prop() private disabled!:boolean;
    @Prop() private min!:number;

    @Prop() private hasError!:boolean;

    // hasError:boolean = true;

    changed(obj:any) {
        this.$emit('input', obj) // update block in parent component
    }
    
}
